import { PRODUCT_LIKE, PRODUCT_DISLIKE } from 'services/Data/constants';

/* Fetch index for given product in Product Browser search results */
export const fetchProductBrowserSearchIndex = ({
  product,
  searchProducts,
  selectedHotspotProduct
}) => {
  let tileCardPlaceInProductGrid;
  /* if product is selected, mark index as 0 */
  if (selectedHotspotProduct && selectedHotspotProduct.id() === product.id()) {
    tileCardPlaceInProductGrid = 0;
  } else {
    const searchProductsIndex = searchProducts.map(
      (searchProduct) => searchProduct.id()
    ).indexOf(product.id());
    /* if another product is selected, increment index by 1 */
    tileCardPlaceInProductGrid = selectedHotspotProduct
      ? searchProductsIndex + 1
      : searchProductsIndex;
  }
  return tileCardPlaceInProductGrid;
};

/**
 * @param  {Object} referralProduct altProduct or hotpost
 * @param {Object} productInitiallySelected instance of product for which user opened the PDP
 * @return {Number} productInitiallySelectedID
 */
export const getAlternativeID = ({ referralProduct, productInitiallySelected }) => {
  if (!referralProduct || !productInitiallySelected) return null;

  const referralProductID = referralProduct.id();
  const productInitiallySelectedID = productInitiallySelected.id();
  const productIDsNotEqual = referralProductID !== productInitiallySelectedID;

  if (productIDsNotEqual) {
    return productInitiallySelectedID;
  }

  return null;
};

/**
 * We expect likeStatus to be a string for our segment analytics.
 * Converts product like status 1/0/-1 into equivalent string status.
 */
export const stringifyLikeStatus = (likeStatusNum) => {
  switch (likeStatusNum) {
    case PRODUCT_LIKE:
      return 'LIKE';
    case PRODUCT_DISLIKE:
      return 'DISLIKE';
    default:
      return 'NEUTRAL';
  }
};
